<ng-container *ngrxLet="defectServicePartIdentification$; let defectServicePartIdentification">
    <fieldset [formGroup]="defectServicePartIdentificationGroup">
        <div class="row mb-3">
            <label class="col col-form-label" for="{{ defectServicePartIdentification.materialNo.xmlId }}">{{
                defectServicePartIdentification.materialNo.label
            }}</label>
            <div class="col">
                <input
                    type="text"
                    class="form-control input-md"
                    id="{{ defectServicePartIdentification.materialNo.xmlId }}"
                    [formControl]="materialNoControl"
                />
            </div>
        </div>
        <div class="row mb-3">
            <label class="col col-form-label" for="{{ defectServicePartIdentification.serialNo.xmlId }}">{{
                defectServicePartIdentification.serialNo.label
            }}</label>
            <div class="col">
                <input
                    type="text"
                    class="form-control input-md"
                    id="{{ defectServicePartIdentification.serialNo.xmlId }}"
                    [formControl]="serialNoControl"
                />
            </div>
        </div>
        <div class="row mb-3">
            <label class="col col-form-label" for="{{ defectServicePartIdentification.orderNo.xmlId }}">{{
                defectServicePartIdentification.orderNo.label
            }}</label>
            <div class="col">
                <input
                    type="text"
                    class="form-control input-md"
                    id="{{ defectServicePartIdentification.orderNo.xmlId }}"
                    [formControl]="orderNoControl"
                />
            </div>
        </div>
    </fieldset>
</ng-container>
